import 'engine/index';
import 'engine/rpc';
import { browserTracingIntegration, captureMessage as SentryCaptureMessage, init as SentryInit, replayIntegration } from '@sentry/browser';
import { qrCodeToId, unreachable } from 'shared/util';

const consoleError = console.error;
console.error = (msg, ...data) => {
	SentryCaptureMessage([msg, ...data].join(' '), 'error');
	consoleError(msg, ...data);
};

SentryInit({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	integrations: [browserTracingIntegration(), replayIntegration()],
	tracesSampleRate: 1.0,
	tracePropagationTargets: [],
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});
import { app, render } from 'engine/index';
import { rpc, State } from 'engine/rpc';
import { showToast, Toast } from 'engine/utils';
import { AlertCircle } from 'lucide-static';
import { Login, signOut, tryLogin } from 'components/Login';
import { TeamKleuren } from './games/team-kleuren-spel';
import { KwaliteitenJacht } from './games/kwaliteiten-jacht';
import { FacilitaireZintuigen } from './games/facilitaire-zintuigen';
import { networkLanguageLoader, setLanguage } from 'shared/translate';
import { Jackpot } from './games/jackpot';
import { VingerAfdrukken } from './games/vinger-afdrukken';
import { Reflectora } from './games/reflectora';
import { BouwHetLandschap } from './games/bouw-het-landschap';
import { Flikken } from './games/flikken-challenge-spel';
import { PlayAndConnect } from './games/play-and-connect';

(async () => {
	await setLanguage('nl', networkLanguageLoader);

	// when users visit from scanning a QR code with their camera get 'code' get param is passed
	// if it exists we try signing in with it immediately and then remove it from the URL
	{
		const url = new URL(window.location.href);
		const code = url.searchParams.get('code');
		if (code && !State.gameToPlay) {
			const id = qrCodeToId(code);
			tryLogin(code, id).then((res) => {
				if (res.success) {
					playGame(res.updates);
				} else {
					showToast(<Toast icon={AlertCircle} title={res.message} closable />, 5000);
				}
			});
			url.searchParams.delete('code');
			window.history.replaceState(null, '', url.toString());
		}
	}

	if (!State.gameToPlay) {
		render(app, <Login onSuccess={(res) => playGame(res.updates)} />);
	} else {
		(async () => {
			const res = await rpc.rejoinPlaySession.query({
				gameId: State.gameId.toString(),
				sessionId: State.sessionId,
				playerId: State.playerId,
			});

			// console.log(res);
			if (res.success) {
				await setLanguage(res.language || 'nl', networkLanguageLoader);

				playGame(res.updates);
			} else {
				console.error('could not rejoin: ' + res.error);
				signOut();
			}
		})();
	}
})();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function playGame(updates: any[]) {
	const g = State.gameToPlay;
	if (!g) return;

	// prettier-ignore
	switch (g) {
		case 'team-kleuren-spel': new TeamKleuren(updates); break;
		case 'kwaliteiten-jacht': new KwaliteitenJacht(updates); break;
		case 'facilitaire-zintuigen-spel': new FacilitaireZintuigen(updates); break;
		case 'jackpot-van-las-vegas': new Jackpot(updates); break;
		case 'vinger-afdrukken-spel': new VingerAfdrukken(updates); break;
		case 'bouw-het-landschap-spel': new BouwHetLandschap(updates); break;
		case 'flikken-challenge': new Flikken(updates); break;
		case 'reflectora-spel': new Reflectora(updates); break;
		case 'play-and-connect-spel': new PlayAndConnect(updates); break;
		default: unreachable(g);
	}

	// rejoined, tell the admin our info
	if (State.gameId != -1 && State.playerId) {
		const player = { gameId: State.gameId, playerId: State.playerId, name: State.name ?? '', color: State.color ?? '' };
		rpc.updatePlayer.query(player);
	}
}
